import {
  ORDER_PAYMENT_STATE_LABELS,
  ORDER_STATUS_LABELS,
  PAYMENT_METHOD_LABELS,
} from "@/constants";
import type { OrderPaymentState, OrderStatus, PaymentMethod } from "@/types";

const ORDER_STATUS_COLORS: Record<OrderStatus, string> = {
  pending: "gold",
  processing: "processing",
  shipped: "blue",
  delivered: "green",
  cancelled: "red",
};

export const formatOrderStatus = (
  status: string | null | undefined,
): string => {
  if (!status) return "";
  const normalized = status.trim().toLowerCase();
  return ORDER_STATUS_LABELS[normalized as OrderStatus] ?? status;
};

export const formatPaymentMethod = (
  paymentMethod: string | null | undefined,
): string => {
  if (!paymentMethod) return "";
  const normalized = paymentMethod.trim().toLowerCase();
  if (
    normalized === "transfer" ||
    normalized === "vietqr" ||
    normalized === "qr"
  ) {
    return PAYMENT_METHOD_LABELS.bank_transfer;
  }
  if (normalized === "cash") {
    return PAYMENT_METHOD_LABELS.cod;
  }
  return PAYMENT_METHOD_LABELS[normalized as PaymentMethod] ?? paymentMethod;
};

export const formatOrderPaymentState = (
  paymentState: string | null | undefined,
): string => {
  if (!paymentState) return "";
  const normalized = paymentState.trim().toLowerCase();
  return (
    ORDER_PAYMENT_STATE_LABELS[normalized as OrderPaymentState] ?? paymentState
  );
};

export const getOrderStatusColor = (
  status: string | null | undefined,
): string => {
  if (!status) return "default";
  const normalized = status.trim().toLowerCase();
  return ORDER_STATUS_COLORS[normalized as OrderStatus] ?? "default";
};
